import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Star } from 'lucide-react';
export function ProofSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-194">
      <div className="max-w-4xl mx-auto" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-196">
          <Card className="bg-secondary text-white border-none shadow-xl overflow-hidden relative" data-id="element-197">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-198"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-primary/20 rounded-full blur-2xl translate-y-1/3 -translate-x-1/4" data-id="element-199"></div>

            <div className="relative z-10 p-3 md:p-4" data-id="element-200">
              <div className="flex justify-center mb-2" data-id="element-201">
                <div className="flex gap-1" data-id="element-202">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-primary text-primary" data-id="element-203" />)}
                </div>
              </div>

              <h2 className="text-xl md:text-2xl font-bold text-center mb-4" data-id="element-204">
                What changes in 72 hours:
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5" data-id="element-205">
                <div className="bg-primary/20 rounded-lg p-4 backdrop-blur-sm border border-primary/30" data-id="element-206">
                  <div className="text-primary font-bold text-xs tracking-wider uppercase mb-1" data-id="element-207">
                    Friday
                  </div>
                  <p className="text-lg md:text-xl font-serif text-black" data-id="element-208">
                    Your child relies on a diaper 100%.
                  </p>
                </div>

                <div className="bg-white rounded-lg p-4 text-foreground shadow-lg transform md:scale-105" data-id="element-209">
                  <div className="text-secondary font-bold text-xs tracking-wider uppercase mb-1" data-id="element-210">
                    Monday Morning
                  </div>
                  <p className="text-lg md:text-xl font-serif font-semibold" data-id="element-211">
                    Your child walks into class in cotton underwear—able to feel
                    the urge and tell their teacher.
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>;
}